import {
  setLecturePromoUsers,
  setLoadLecturePromoUsers,
} from "pages/Cabinet/redux/reducer";
import { TThunkDispatch } from "store";
import axios from "axios";
import { API_URL, getHeaderWithAuthorization } from "./API";

export const getCabinetLecturePromoUsers =
  (id: number) => async (dispatch: TThunkDispatch) => {
    dispatch(setLoadLecturePromoUsers(true));
    try {
      const resp = await axios.post(
        `${API_URL}v2/webinar/users/${id}?size=999`,
        {},
        {
          headers: getHeaderWithAuthorization(),
        }
      );
      dispatch(setLecturePromoUsers(resp.data.items));
    } catch (err: any) {
      console.log({ err });
    }
  };

export const getBaseCoursesLessonByTopic = async (
  topic_id: string
): Promise<any> => {
  try {
    return await axios.post(
      `${API_URL}v1/base-course/lessons?size=999`,
      {
        topic_id,
      },
      {
        headers: getHeaderWithAuthorization(),
      }
    );
  } catch (err: any) {
    console.log({ err });
  }
};

export const getBaseCoursesTopics = async (): Promise<any> => {
  try {
    return await axios.post(
      `${API_URL}v1/base-course/topics?size=999`,
      {},
      {
        headers: getHeaderWithAuthorization(),
      }
    );
  } catch (err: any) {
    console.log({ err });
  }
};

export const getBaseCourseLessonById = async (id: string): Promise<any> => {
  try {
    return await axios.get(`${API_URL}v1/base-course/lesson-info?id=${id}`, {
      headers: getHeaderWithAuthorization(),
    });
  } catch (err: any) {
    console.log({ err });
  }
};

export const sendWatchVideoBaseCourse = async (id: string): Promise<any> => {
  try {
    return await axios.post(
      `${API_URL}v1/base-course/set-watched`,
      { lesson_id: id },
      {
        headers: getHeaderWithAuthorization(),
      }
    );
  } catch (err: any) {
    console.log({ err });
  }
};

export const getBillingOrdered = async (): Promise<any> => {
  try {
    return await axios.post(
      `${API_URL}v2/billing/service/ordered?size=999`,
      {},
      {
        headers: getHeaderWithAuthorization(),
      }
    );
  } catch (err: any) {
    console.log({ err });
  }
};


export const payBillingItem = async (
  id: number,
  amount: string
): Promise<any> => {
  try {
    return await axios.post(
      `${API_URL}v2/billing/order/link`,
      {
        service_user_id: id,
        amount: amount,
      },
      {
        headers: getHeaderWithAuthorization(),
      }
    );
  } catch (err: any) {
    console.log({ err });
  }
};

export const getBillingAllServices = async (): Promise<any> => {
  try {
    return await axios.post(
      `${API_URL}v2/billing/service`,
      {},
      {
        headers: getHeaderWithAuthorization(),
      }
    );
  } catch (err: any) {
    console.log({ err });
  }
};

export const addBillingServiceUser = async (ids: number[]): Promise<any> => {
  try {
    return await axios.post(
      `${API_URL}v2/billing/order/add`,
      { ids },
      {
        headers: getHeaderWithAuthorization(),
      }
    );
  } catch (err: any) {
    console.log({ err });
  }
};

export const getBaseCourseProgress = async (): Promise<any> => {
  try {
    return await axios.get(`${API_URL}v1/base-course/progress`, {
      headers: getHeaderWithAuthorization(),
    });
  } catch (err: any) {
    console.log({ err });
  }
};
